import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';
import { BasicText, MetricStackTitle, PageWrapper, ShinyBlockOuter, ShinyBody, ShinyHeading } from '../Styles';
import File from './File';
import Modal from '../core/Modal';
import Util from '../core/Util';

//<File onUpload={uploaded} storeIn="db" useExisting={true} label={refreshMessage ? refreshMessage : "Drop Invoice Here"} info={uploadMessage} bigDrop={true}/>

const InvoiceImporter = ({ portalData }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    useEffect(()=>{
        if(modalVisible == false){
            setModalContent(null);
        }
    }, [modalVisible]);

    const doUpload = (result) => {
        const file = result;

        if (file != undefined) {
            if (file.filename.toLowerCase().indexOf("pdf") >= 0) {
                fetch(Util.getHost() + "/api/v1/import/processPortalPDF", {
                    method: "POST",
                    body: JSON.stringify({
                        fileId: file.id,
                        sourceCustomer: portalData.user.customer.id
                    })
                }).then((p) => p.json()).then((p) => {
                    setModalContent(<BasicText>Upload successful. Your invoice will take a moment to process. Please check back in a few minutes.</BasicText>);
                    setModalVisible(true);
                });
            } else {
                setModalContent(<BasicText>Incorrect file type. Please select a pdf and try again.</BasicText>);
                setModalVisible(true);
            }
        }
    }

    if (portalData == null || portalData.user == null || portalData.user.customer == null || portalData.user.portalProfileSettings == null || portalData.user.portalProfileSettings.selfServeInvoiceAccess != true) {
        return null;
    }

    if(Util.isMobile()){
        return null;
    }

    return <ShinyBlockOuter minHeight={400} flexBasis="99%">
        <Modal modalVisible={modalVisible} setModalVisible={setModalVisible}>
            {modalContent}
        </Modal>
        <ShinyHeading>
            <MetricStackTitle>Invoice Importer</MetricStackTitle>
        </ShinyHeading>
        <ShinyBody>
            <View>
                <File onUpload={doUpload} label={"Drop Invoice Here"} />
            </View>
        </ShinyBody>
    </ShinyBlockOuter>;
}

export default InvoiceImporter;